<template>
<div>
    <div class="md-layout">
        <div class="md-layout-item md-medium-size-35 md-xsmall-size-100 md-size-35">
            <stats-card header-color="primary">
                <template slot="header">
                    <div class="card-icon">
                        <i class="fas fa-money-check-alt"></i>
                    </div>
                    <h4 class="title">
                    EMPRESAS
                    </h4>
                </template>

                <template slot="footer">
                    <div class="stats">
                        {{ homeAdm.empresas }}
                    </div>
                </template>
            </stats-card>
        </div>

        <div class="md-layout-item md-medium-size-35 md-xsmall-size-100 md-size-35">
            <stats-card header-color="rose">
                <template slot="header">
                    <div class="card-icon">
                        <i class="fas fa-money-check-alt"></i>
                    </div>
                    <h4 class="title">
                    FORNECEDORES
                    </h4>
                </template>

                <template slot="footer">
                    <div class="stats">
                        {{ homeAdm.fornecedores }}
                    </div>
                </template>
            </stats-card>
        </div>

        <div class="md-layout-item md-medium-size-30 md-xsmall-size-100 md-size-30">
            <stats-card header-color="green">
                <template slot="header">
                    <div class="card-icon">
                        <i class="fas fa-users"></i>
                    </div>
                    <h4 class="title">
                    CLIENTES
                    </h4>
                </template>

                <template slot="footer">
                    <div class="stats">
                        {{ homeAdm.clientes }}
                    </div>
                </template>
            </stats-card>
        </div>
    </div>
</div>
</template>

<script>
import {
    StatsCard,
    AnimatedNumber
} from "@/components";
import Notify from '@/config/mixins/notify'

export default {
    components: {
        StatsCard
    },

    data() {
        return {
            homeAdm: {}
        };
    },

    created() {
        this.getHomeAdm();
    },

    mixins: [Notify],

    methods: {
        getHomeAdm() {
            this.$http.get(this.$urlAPI + 'home/adm')
                .then(response => {
                    if(response.data.status){
                        this.homeAdm = response.data.dados
                    } else{
                        this.danger(response.data.message)
                    }
                })
                .catch(e => {
                    this.msgErrors(e)
                })
        }
    },
};
</script>
